"use client";

import React from "react";
import RolesAside from "../roles/RolesAside";
import RoleHeader from "../roles/RoleHeader";
import PermissionComparison from "../roles/PermissionComparison";

const RolesManagement: React.FC = () => {
  return (
    <>
      <section className="flex flex-col md:flex-row w-full gap-6">
        {/* Aside - 25% on medium screens and above, full width on mobile */}
        <aside className="w-full md:w-1/4 overflow-y-auto border rounded-lg shadow-sm bg-white h-[calc(100vh-12rem)]">
          <RolesAside />
        </aside>

        {/* Main Section - 75% on medium screens and above, full width on mobile */}
        <section className="w-full md:w-3/4 space-y-6">
          {/* Role header */}
          <RoleHeader />

          {/* Permissions grid */}
          <PermissionComparison />
        </section>
      </section>
    </>
  );
};

export default RolesManagement;
